// extracted by mini-css-extract-plugin
export var adjacentSlide = "_s9-9";
export var arrowButtonContainer = "_s9-5";
export var arrowButtonIcon = "_s9-6";
export var carouselArrowButton = "_s9-2";
export var carouselElementContainer = "_s9-1";
export var currentSlide = "_s9-8";
export var left = "_s9-3";
export var otherSlide = "_s9-a";
export var productCarouselContainer = "_s9-0";
export var right = "_s9-4";
export var sliderOverflow = "_s9-7";